
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface InfoCardProps {
  title: string;
  message: string;
  icon?: string;
  colorScheme?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ 
  title, 
  message, 
  icon = "📢", 
  colorScheme = "bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200" 
}) => {
  return (
    <Card className={colorScheme}>
      <CardContent className="pt-6">
        <div className="text-center text-sm text-blue-700">
          <p className="font-medium mb-2">{icon} {title}</p>
          <p>{message}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default InfoCard;
